Ext.define('SA.HistogramViewState', {
    constructor({request, modelState, availableSpace, firstResultPending}) {
        this.defineGetters();

        this.request = request;
        this.modelState = modelState;
        this.availableSpace = availableSpace;
        this.firstResultPending = firstResultPending;
        this.binSizeState = this.getBinSizeState();
    },

    defineGetters() {
        Object.defineProperty(this, 'model', {get: () => this.modelState});
        Object.defineProperty(this, 'binSize', {get: () => this.binSizeState});
    },

    getBinSizeState() {
        var requestResult = this.request.getResult(),
            maybeData = requestResult && requestResult.getData(),
            getModelState = property => this.modelState.binSize[property],
            hasCustomSize = getModelState('isCustom'),
            supportsFractions = getModelState('supportsFractions'),
            format = size => size === null ? '' : SA.formatValue(size, getModelState('format')),
            size = null;

        if (hasCustomSize) {
            size = getModelState('size');
        }
        else if (maybeData) {
            size = maybeData.getBinSize();
        }

        return {size, formattedSize: format(size), hasCustomSize, supportsFractions};
    }
});